import styled, { css } from 'styled-components';
import { Column } from 'components/layout';
import { color } from 'styles/settings';
import { ReactComponent as _FullLine } from './../../icons/full-line.svg';
import { ReactComponent as _DashedLine } from './../../icons/dashed-line.svg';

const iconSize = css`
  width: 30px;
  height: 15px;
  color: ${({ color }) => color};
  cursor: pointer;
`;

export const Container = styled(Column)`
  position: relative;
  margin: 0 20px;
`;

export const FullLine = styled(_FullLine)`
  ${iconSize};
`;

export const DashedLine = styled(_DashedLine)`
  ${iconSize};
`;

export const ShapeDropdownContainer = styled.div`
  flex: 1;
  position: absolute;
  top: 35px;
  left: -12px;
`;

export const ShapeDropdownMenu = styled.div`
  align-items: center;
  background-color: ${color.neutral.white};
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  padding-bottom: 7px;
  position: relative;
  top: 20px;
  width: 28px;

  :before {
    content: '';
    position: absolute;
    top: -8px;
    transform: rotateX(180deg);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #fff;
    clear: both;
  }
`;

export const SelectedShapeContainer = styled.div`
  color: ${({ color }) => color};
`;

export const ShapeOptionContainer = styled.div`
  margin-bottom: 9px;
  color: ${({ color }) => color};
`;

export const ShapeOption = styled.span``;
